import { useEffect, useState } from "react";

import {
  TableRow,
  TableCell,
  Typography,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";

import moment from "moment";

import UploadDocumentModal from "../AddKnowledgebase/UploadDocument";

import UploadFileIcon from "@mui/icons-material/UploadFile";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import SyncIcon from "@mui/icons-material/Sync";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

interface IProps {
  document: any;
  handleStatusColor: any;
  handleOpenUploadDocumentModal: any;
  handleRetrainDocuments: any;
  handleOpenConfirmDeleteModal: any;
  handleOpenImportWebsiteModal: any;
  handleFetchStoredDocuments: any;
  setFileUploading: any;
  handleGetS3Url: any;
  isChatGPTAPIKeyValid?: boolean;
}

const CollapsableRow = ({
  document,
  handleStatusColor,
  handleOpenUploadDocumentModal,
  handleRetrainDocuments,
  handleOpenConfirmDeleteModal,
  handleOpenImportWebsiteModal,
  handleFetchStoredDocuments,
  setFileUploading,
  handleGetS3Url,
  isChatGPTAPIKeyValid,
}: IProps) => {
  const [open, setOpen] = useState(false);
  const [uploadDocumentModal, setUploadDocumentModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<any | null>(null);

  const handleOpenUploadDocumentRetrainModal = (file: any) => {
    setUploadDocumentModal(true);
    setSelectedFile(file);
  };

  const handleCloseUploadDocumenRetraintModal = () => {
    setUploadDocumentModal(false);
    setSelectedFile(null);
  };

  useEffect(() => {
    if (document?.fields?.length === 0) {
      setOpen(false);
    }
  }, [document?.fields]);

  const getKBArtcStatus = (data: any) => {
    let status;
    switch (data) {
      case "Processing":
        status = "Retraining in progress";
        break;
      case "retraining":
        status = "Live";
        break;
      default:
        status = data;
    }
    return status;
  };

  return (
    <>
      <TableRow
        key={document._id}
        sx={{
          borderBottom: open ? "0" : "1px solid #dbdce0",
        }}
      >
        <TableCell
          sx={{
            width: "75px",
            "&.MuiTableCell-body": {
              borderBottom: "0!important",
              paddingBottom: open ? "0!important" : "iherit",
            },
          }}
        >
          {document?.fields.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
              sx={{
                padding: 0,
              }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell
          sx={{
            width: "350px",
            "&.MuiTableCell-body": {
              borderBottom: "0!important",
              paddingBottom: open ? "0!important" : "iherit",
            },
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSized: "12px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "350px",
            }}
          >
            {document?.name}
          </Typography>
        </TableCell>

        <TableCell
          sx={{
            "&.MuiTableCell-body": {
              borderBottom: "0!important",
              paddingBottom: open ? "0!important" : "iherit",
            },
          }}
        >
          <Typography />
        </TableCell>

        <TableCell
          sx={{
            "&.MuiTableCell-body": {
              borderBottom: "0!important",
              paddingBottom: open ? "0!important" : "iherit",
            },
          }}
        >
          <Typography />
        </TableCell>

        <TableCell
          sx={{
            "&.MuiTableCell-body": {
              borderBottom: "0!important",
              paddingBottom: open ? "0!important" : "iherit",
            },
          }}
        >
          <Typography />
        </TableCell>
        <TableCell
          sx={{
            "&.MuiTableCell-body": {
              borderBottom: "0!important",
              paddingBottom: open ? "0!important" : "iherit",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "5px",
              "button": {
                padding: 0,
              },
            }}
          >
            <div className="guideTourKBActions">
              <Tooltip title="Upload document" placement="top">
                <IconButton
                  onClick={() => {
                    handleOpenUploadDocumentModal(document);
                  }}
                >
                  <UploadFileIcon
                    sx={{
                      color: "#000000b8",
                      fontSize: "18px",
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Import website" placement="top">
                <IconButton
                  onClick={() => {
                    handleOpenImportWebsiteModal(document);
                  }}
                >
                  <ImportExportIcon
                    sx={{
                      color: "#000000b8",
                      fontSize: "18px",
                    }}
                  />
                </IconButton>
              </Tooltip>
            </div>
            {document?.fields.length === 0 && (
              <Tooltip title="Delete" placement="top">
                <IconButton
                  onClick={() => handleOpenConfirmDeleteModal(document)}
                >
                  <DeleteIcon
                    sx={{
                      color: "#000000b8",
                      fontSize: "16px",
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </TableCell>
      </TableRow>
      {open && (
        <TableRow
          key={document._id}
          sx={{
            borderBottom: open ? "0" : "1px solid #dbdce0",
          }}
        >
          <TableCell
            sx={{
              width: "75px",
              "&.MuiTableCell-body": {
                borderBottom: open ? "1px solid #dbdce0" : "0!important",
                paddingBottom: open ? "0!important" : "iherit",
              },
            }}
          />
          <TableCell
            className="pro-title"
            sx={{
              width: "350px",
              "&.MuiTableCell-body": {
                borderBottom: open ? "1px solid #dbdce0" : "0!important",
              },
            }}
          >
            {document.fields.map((e: any) => {
              return (
                <Typography
                  sx={{
                    mt: 1,
                    textDecoration: "underline",
                    color: "#0157ff !important",
                    cursor: "pointer",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "350px",
                    paddingLeft: "32px",
                    "&::before": {
                      content: '""',
                      backgroundColor: "#000000b8",
                      verticalAlign: "middle",
                      display: "inline-block",
                      margin: "0px 8px 1px 0",
                      borderRadius: "50%",
                      width: "5px",
                      height: "5px",
                    },
                  }}
                >
                  {e.userFileName ?? e.filename}
                </Typography>
              );
            })}
          </TableCell>

          <TableCell
            sx={{
              "&.MuiTableCell-body": {
                borderBottom: open ? "1px solid #dbdce0" : "0!important",
              },
            }}
          >
            {document.fields.map((e: any) => {
              return (
                <Typography
                  sx={{
                    mt: 1,
                    textTransform: "capitalize",
                    fontWeight: 500,
                    color: `${handleStatusColor(e.status)}!important`,
                  }}
                >
                  {getKBArtcStatus(e.status)}
                </Typography>
              );
            })}
          </TableCell>

          <TableCell
            sx={{
              "&.MuiTableCell-body": {
                borderBottom: open ? "1px solid #dbdce0" : "0!important",
              },
            }}
          >
            {document.fields.map((e: any) => {
              return (
                <Typography
                  sx={{
                    mt: 1,
                  }}
                >
                  {moment(e?.lastModifiedOn).format("MM/DD/YYYY")}
                </Typography>
              );
            })}
          </TableCell>

          <TableCell
            sx={{
              "&.MuiTableCell-body": {
                borderBottom: open ? "1px solid #dbdce0" : "0!important",
              },
            }}
          >
            {document.fields.map((e: any) => {
              return (
                <Typography
                  sx={{
                    mt: 1,
                  }}
                >
                  {moment(e?.createdOn).format("MM/DD/YYYY")}
                </Typography>
              );
            })}
          </TableCell>
          <TableCell
            sx={{
              "&.MuiTableCell-body": {
                borderBottom: open ? "1px solid #dbdce0" : "0!important",
              },
            }}
          >
            {document.fields.map((e: any) => {
              return (
                <Box
                  sx={{
                    mt: 1,
                    height: "21px",
                    display: "flex",
                    gap: "5px",
                    "button": {
                      padding: 0,
                    },
                  }}
                >
                  {e.type === "url" && e.status === "live" && (
                    <Tooltip title="Retrain" placement="top">
                      <IconButton onClick={() => handleRetrainDocuments(e.id)}>
                        <SyncIcon
                          sx={{
                            color: "#000000b8",
                            fontSize: "16px",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  )}

                  {e.type === "doc" && e.status === "live" && (
                    <Tooltip title="Retrain" placement="top">
                      <IconButton
                        onClick={() => handleOpenUploadDocumentRetrainModal(e)}
                      >
                        <SyncIcon
                          sx={{
                            color: "#000000b8",
                            fontSize: "16px",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  )}

                  {(e.status === "live" || e.status === "error") && (
                    <Tooltip title="Delete" placement="top">
                      <IconButton
                        onClick={() => handleOpenConfirmDeleteModal(e)}
                      >
                        <DeleteIcon
                          sx={{
                            color: "#000000b8",
                            fontSize: "16px",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  )}

                  {uploadDocumentModal && selectedFile?.id === e.id && (
                    <UploadDocumentModal
                      open={uploadDocumentModal}
                      onClose={handleCloseUploadDocumenRetraintModal}
                      handleFetchStoredDocuments={handleFetchStoredDocuments}
                      setFileUploading={setFileUploading}
                      selectedFolder={selectedFile}
                      handleGetS3Url={handleGetS3Url}
                      isChatGPTAPIKeyValid={isChatGPTAPIKeyValid}
                      isRetrain
                    />
                  )}
                </Box>
              );
            })}
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default CollapsableRow;
